export const removeNullAndEmptyFields = <T>(obj: T, preserveArrays = false): Partial<T> => {
    if (obj === null || obj === undefined) {
        return {}
    }

    if (Array.isArray(obj)) {
        const cleanedArray = obj
            .map((item) => removeNullAndEmptyFields(item, preserveArrays))
            .filter((item) => {
                if (item === null || item === undefined) return false

                if (
                    typeof item === 'object' &&
                    !Array.isArray(item) &&
                    Object.keys(item).length === 0
                ) {
                    return false
                }

                if (typeof item === 'string' && (item as string).trim() === '') {
                    return false
                }

                return true
            })

        return cleanedArray.length > 0 || preserveArrays ? (cleanedArray as any) : undefined
    }

    if (typeof obj !== 'object') {
        if (typeof obj === 'string' && obj.trim() === '') {
            return undefined
        }
        return obj
    }

    const cleanedObj: any = {}

    Object.keys(obj as any).forEach((key) => {
        const value = (obj as any)[key]

        if (value === null || value === undefined) {
            return
        }

        if (typeof value === 'string' && value.trim() === '') {
            return
        }

        if (typeof value === 'object') {
            const cleanedValue = removeNullAndEmptyFields(value, preserveArrays)

            if (Array.isArray(cleanedValue)) {
                if (cleanedValue.length > 0 || preserveArrays) {
                    cleanedObj[key] = cleanedValue
                }
            } else if (cleanedValue && Object.keys(cleanedValue).length > 0) {
                cleanedObj[key] = cleanedValue
            }
        } else {
            cleanedObj[key] = value
        }
    })

    return cleanedObj
}

export const cleanFormDataForAPI = <T extends Record<string, any>>(formData: T): T => {
    if (!formData || typeof formData !== 'object') {
        return formData
    }

    const result: any = {...formData}

    Object.keys(result).forEach((key) => {
        const value = result[key]

        if (
            value === null ||
            value === undefined ||
            (typeof value === 'string' && value.trim() === '')
        ) {
            delete result[key]
        }
        else if (typeof value === 'object' && !Array.isArray(value)) {
            const cleanedNested = cleanFormDataForAPI(value)
            if (cleanedNested && Object.keys(cleanedNested).length > 0) {
                result[key] = cleanedNested
            } else {
                delete result[key]
            }
        }
        else if (Array.isArray(value)) {
            const cleanedArray = value.filter(
                (item) =>
                    item !== null &&
                    item !== undefined &&
                    !(typeof item === 'string' && item.trim() === '')
            )
            if (cleanedArray.length > 0) {
                result[key] = cleanedArray
            } else {
                delete result[key]
            }
        }
    })

    return result
}

export const removeEmptyContainers = <T>(data: T): Partial<T> => {
    if (data === null || data === undefined) {
        return {}
    }

    if (Array.isArray(data)) {
        const cleanedArray = data
            .map((item) => removeEmptyContainers(item))
            .filter((item) => {
                if (item === null || item === undefined) return false
                if (
                    typeof item === 'object' &&
                    !Array.isArray(item) &&
                    Object.keys(item).length === 0
                ) {
                    return false
                }
                return true
            })

        return cleanedArray.length > 0 ? (cleanedArray as any) : undefined
    }

    if (typeof data !== 'object') {
        return data
    }

    const cleanedObj: any = {}

    Object.keys(data as any).forEach((key) => {
        const value = (data as any)[key]

        if (value === null || value === undefined) {
            return
        }

        if (typeof value === 'object') {
            const cleanedValue = removeEmptyContainers(value)

            if (Array.isArray(cleanedValue)) {
                if (cleanedValue.length > 0) {
                    cleanedObj[key] = cleanedValue
                }
            } else if (cleanedValue && Object.keys(cleanedValue).length > 0) {
                cleanedObj[key] = cleanedValue
            }
        } else {
            cleanedObj[key] = value
        }
    })

    return cleanedObj
}
